import { NavLeftLayout } from 'vopay';
import { useHistory } from 'react-router-dom';
import { useNavMenu } from '../../../providers/NavMenu.provider';
import { useOpenModule } from '../../../providers/OpenModule.provider';
import NavigationMenu from '../NavigationMenu/NavigationMenu';

type NavLeftContainerType = {
  logo?: string;
  smallLogo?: string;
  expandMenu?: boolean;
};

const NavLeftContainer: React.FC<NavLeftContainerType> = ({ logo, smallLogo, expandMenu }) => {
  const history = useHistory();
  const { onNavClick } = useNavMenu();
  const { setOpenModule } = useOpenModule();

  return (
    <NavLeftLayout
      logo={logo}
      smallLogo={smallLogo}
      onLogoClick={() => {
        onNavClick('dashboard');
        setOpenModule('dashboard');
        history.push('/dashboard');
      }}
      navMenu={<NavigationMenu expandMenu={expandMenu} />}
      expandMenu={expandMenu}
    />
  );
};

export default NavLeftContainer;
